<template>
    <div class="goods-item-view" @click='goodsItemClick(goods.id)'>
        <img class="img" v-if="goods" v-lazy="goods.img" />
        <p v-if="goods" class="title">{{ goods.title }}</p>
        <p v-if="goods" class="desc">{{ goods.desc }}</p>
        <p v-if="goods" class="other">
            <span v-if="goods" class="now-price">${{ goods.nowPrice }}</span>
            <span v-if="goods" class="old-price">${{ goods.oldPrice }}</span>
            <span v-if="goods" class="rebate">{{ goods.rebate }}折</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "goodsItemView",
        props: ["goods"],
        methods: {
            goodsItemClick: function (goodsId) {
                // console.log(goodsId);
                //調用狀態管理器:改變goodsDetailShow狀態
                this.$store.commit("changeGoodsDetailShow");
                this.$store.commit("changeGoodsItemId", goodsId);
            }
        }
    };
</script>

<style lang="scss">
    .goods-item-view {
        width: 50%;
        padding: 5px;
        border-right: 1px solid #bbbbbb;
        border-bottom: 1px solid #bbbbbb;
        float: left;
        box-sizing: border-box;
        background-color: white;
        text-align: center;
        .img {
            width: 100%;
            margin-top: 10px;
        }

        .title {
            font-size: 12px;
            color: black;
            margin-bottom: 10px;
        }
        .desc {
            font-size: 13px;
            color: #b4b4b4;
            margin-bottom: 13px;
        }
        .now-price {
            font-size: 15px;
            font-weight: 800;
            color: red;
            margin-right: 8px;
        }
        .old-price {
            font-size: 12px;
            color: #b4b4b4;
            margin-right: 8px;
            text-decoration: line-through;
        }
        .rebate {
            font-size: 12px;
            color: white;
            background-color: red;
            border-radius: 33px;
            width: 40px;
            line-height: 12px;
            margin-right: 8px;
            display: inline-block;
        }
    }
</style>
